export interface ExampleMediaSessionPluginPlugin {
  echo(options: { value: string }): Promise<{ value: string }>;
}
